var React = require('react');

function LongArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M76 5.99999L66 0.226491L66 11.7735L76 5.99999ZM8.74228e-08 7L67 6.99999L67 4.99999L-8.74228e-08 5L8.74228e-08 7Z","fill":"black"}));
}

LongArrow.defaultProps = {"width":"76","height":"12","viewBox":"0 0 76 12","fill":"none"};

module.exports = LongArrow;

LongArrow.default = LongArrow;
